import { render, staticRenderFns } from "./Fact.vue?vue&type=template&id=6015685c&"
import script from "./Fact.vue?vue&type=script&lang=js&"
export * from "./Fact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Fact.vue"
export default component.exports